module.exports = __webpack_public_path__ + "static/media/intro_title_mobile.44c4b12b.png";